import { render, staticRenderFns } from "./reportCustomComponentRelManage.vue?vue&type=template&id=6dae2407&scoped=true"
import script from "./reportCustomComponentRelManage.vue?vue&type=script&lang=js"
export * from "./reportCustomComponentRelManage.vue?vue&type=script&lang=js"
import style0 from "./reportCustomComponentRelManage.vue?vue&type=style&index=0&id=6dae2407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae2407",
  null
  
)

export default component.exports